module.exports = __webpack_public_path__ + "img/video.3242c047.png";